import { z } from 'zod';

import { ParameterizedString } from './strings';

// Eventually we'll want graphql-codegen to be able to generate these Zod types,
// but there's currently a limitation in that we can't configure the nullish type
// in the plugin. I've created an issue here https://github.com/Code-Hex/graphql-codegen-typescript-validation-schema/issues/308
export const SchemaTxMatchInput = z.object({
  id: z.optional(ParameterizedString),
  externalId: z.optional(ParameterizedString),
});

export const txTypes = ['credit', 'debit'] as const;

export const TxTypeSchema = z.enum(txTypes);
export type TxType = z.infer<typeof TxTypeSchema>;
